import { getEnvironmentVariables } from './config.default';

const environmentVariables = getEnvironmentVariables({ environment: 'fairyfloss', domain: 'moshtix.com.au' });

export default environmentVariables;
